import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { ButtonType } from '@design-system/components/molecules/button/entities/button.types';

@Component({
  selector: 'app-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FormErrorComponent {

  @Input() imageUrl: string;
  @Input() title: string;
  @Input() description: string;
  @Input() textButton: string;
  @Input() textSecondaryButton: string;
  @Input() isMobile: boolean;

  @Output() closed: EventEmitter<void> = new EventEmitter<void>();
  @Output() mainButton: EventEmitter<void> = new EventEmitter<void>();
  @Output() secondaryButton: EventEmitter<void> = new EventEmitter<void>();

  public readonly cancelBtnDsType = ButtonType.Secondary;

  constructor() { }

}
